/* unplugin-vue-components disabled */import script from "./SettlementTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementTable.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementTable.vue?vue&type=style&index=0&id=937766ca&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-937766ca"]])

export default __exports__